import axios from "axios";
import { userDataLocalStorage } from "../../../general/functions/base64Function";
import {
  SMVM_RECORDING_FAIL,
  SMVM_RECORDING_REQUEST,
  SMVM_RECORDING_RESET,
  SMVM_RECORDING_SUCCESS,
} from "../constants/recordingConstants";
import { API_START_RECORD } from "../init/api_url";

export const RStartRecording = (data) => async (dispatch) => {
  dispatch({
    type: SMVM_RECORDING_RESET,
  });
};

export const StartRecording = (projectCode) => async (dispatch) => {
  const { token, session } = userDataLocalStorage();
  let d = session.split("-");
  let sessionId = d[2];
  try {
    dispatch({
      type: SMVM_RECORDING_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data: data } = await axios.post(
      API_START_RECORD(projectCode, sessionId),
      {},
      config
    );

    dispatch({
      type: SMVM_RECORDING_SUCCESS,
      payload: data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: SMVM_RECORDING_FAIL,
      payload: message,
    });
  }
};
